import type PlantModel from "Models/Plant";
import type VarietyModel from "Models/Variety";
import SearchableReactDropdown from "./SearchableReactDropdown";
import { getPlantDisplayName } from "Helpers/PlantName";

interface PlantCompanionPlantsFieldProps {
  plants: PlantModel[];
  varieties: VarietyModel[];
  companionPlantIds: string[];
  onChange: (plantIds: string[]) => void;
  onCreatePlant: () => void;
}

const PlantCompanionPlantsField = ({
  plants,
  varieties,
  companionPlantIds,
  onChange,
  onCreatePlant,
}: PlantCompanionPlantsFieldProps) => (
  <div className="w-full px-5 md:w-1/2">
    <h5>Companion Plants</h5>
    <SearchableReactDropdown
      options={plants}
      getOptionLabel={(plant) => getPlantDisplayName(plant, varieties)}
      getOptionValue={(plant) => plant._id}
      value={companionPlantIds[companionPlantIds.length - 1] ?? ""}
      controlClassName="border rounded px-5 text-lg cursor-pointer mt-[10px]"
      menuClassName="border rounded cursor-pointer"
      arrowClassName="py-5"
      placeholder="Select Companion Plants"
      actionButton={{ label: "Create Plant", onClick: onCreatePlant }}
      onChange={(selectedPlant) => {
        onChange(
          companionPlantIds.includes(selectedPlant._id)
            ? companionPlantIds
            : [...companionPlantIds, selectedPlant._id],
        );
      }}
    />
    {companionPlantIds.length > 0 && (
      <div className="grid grid-cols-2 gap-2">
        <h3 className="text-lg font-semibold">Selected Companion Plants:</h3>
        <div>
          {companionPlantIds.map((plantId) => {
            const companionPlant = plants.find(
              (candidate) => candidate._id === plantId,
            );
            const name =
              getPlantDisplayName(companionPlant, varieties) || plantId;
            return (
              <div key={plantId} className="flex">
                <p className="pr-10 flex-grow justify-center items-center flex">
                  {name}
                </p>
                <button
                  className="text-white my-1 p-2 bg-red"
                  onClick={() =>
                    onChange(
                      companionPlantIds.filter(
                        (selectedPlantId) => selectedPlantId !== plantId,
                      ),
                    )
                  }
                >
                  X
                </button>
              </div>
            );
          })}
        </div>
      </div>
    )}
  </div>
);

export default PlantCompanionPlantsField;
